export const initialState = {
  isFetching: false,
  orderId: '',
  products: [],
}

export const setItems = (state, payload) => (
  { ...payload, isFetching: false }
)

export const setFetchingStatus = (state, payload) => (
  { ...state, isFetching: payload }
)

export const reset = () => initialState
